<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteContenidoNodo"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAssetContentsModalDeleteContent.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionAssetContentsModalDeleteContent.messageDelete.element') }}
          <b>{{ $modal.element.nombre }}</b>
          {{ $t('mEditionAssetContentsModalDeleteContent.messageDelete.options') }}
        </p>
        <small class="text-color-danger">
            {{ $t('mFeedAssetsContentModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAssetContentsModalDeleteContent.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContentsModalDeleteContent',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionAssetContentsModalDeleteContent.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  methods: {
    deleteContenidoNodo () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('contenido', 'deleteContenidoNodo', {}, [this.$modal.element.contenido, this.$modal.element.id])
          .then(response => {
            this.$modal.updateData('readElement')
            setTimeout(() => { this.$modal.updateData('readContenidoEntregables') }, 4000)
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionAssetContentsModalDeleteContent', 'deleteContenidoNodo', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetContentsModalDeleteContent', 'deleteContenidoNodo', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
